var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRecipe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.073,
    height: 21.073,
    viewBox: "0 0 21.073 21.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3533",
    "data-name": "Trazado 3533",
    d: "M0,0H21.073V21.073H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3534",
    "data-name": "Trazado 3534",
    d: "M2,3.872A.878.878,0,0,1,2.871,3H18.689a.872.872,0,0,1,.871.872V17.933a.878.878,0,0,1-.871.872H2.871A.872.872,0,0,1,2,17.933Zm1.756.884V17.048H17.8V4.756ZM5.512,6.512H10.78V11.78H5.512ZM7.268,8.268v1.756H9.024V8.268ZM5.512,13.536H16.048v1.756H5.512Zm7.024-7.024h3.512V8.268H12.536Zm0,3.512h3.512V11.78H12.536Z",
    transform: "translate(-0.244 -0.366)",
    fill: "#9a41a5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecipe);
export default __webpack_public_path__ + "static/media/icon-recipe.68f6991f648f0c643ae287c6e0bd3caf.svg";
export { ForwardRef as ReactComponent };